import React, { useState, useEffect } from 'react';
import { Form, Select, Input, Checkbox, Spin, Button } from 'antd';
import { connect } from 'react-redux';

import { Toast } from '@components';
import { API } from '@service';
import actions from '@flux/action';
import useReportIssuePageList from './useReportIssuePageList';
import { getSessionStorage } from '@utils/windowUtil';

const { Item } = Form;
const { Option } = Select;
const { TextArea } = Input;
const connectedPageArr = [
  'Project List',
  'Create Project',
  'Project Setting',
  'Project Home - Deal Complexity',
  'Project Home - Integration Navigator',
  'Project Home - M&A Lifecycle',
  'Project Home - Report Builder',
  'Questionnaire',
  'Review Response',
  'Deal Complexity',
  'Analysis - Company Overview',
  'Analysis - Financials',
  'Analysis - Go-To-Market',
  'Analysis - Operational Footprint',
  'Analysis - Sentiment Analysis',
  'Analysis - ESG',
  'Insights - Integration Approach',
  'Insights - Value Drivers',
  'Insights - Guiding Principle',
  'Insights - Deal Rationale',
  'Insights - Insights',
  'Customized Module',
];

const categoryArr = [
  'Data is incorrect',
  "I can't find my company",
  "I can't add users",
  "I'd like to provide feedback on improving or adding a feature",
  'Other',
];

const ReportIssue = ({ isShow, close: _close, userInfo, defaultValues }) => {
  const [form] = Form.useForm();
  const [descriptionText, setDescriptionText] = useState('');
  const [isLoading, setIsloading] = useState(false);
  const [disable, setDisable] = useState(true);
  const limitNum = 500;
  const [placeholder, setPlaceholder] = useState('');
  const [hasSelectedNoCompany, setSelectedNoCompany] = useState(false);

  const { isLoading: dataLoading, connectedPages } =
    useReportIssuePageList(isShow);

  console.log('connected pages : ', connectedPages);

  const close = () => {
    _close();
    setDescriptionText('');
    form.resetFields();
  };

  const onFinish = async (vals) => {
    setIsloading(true);
    const data = {
      projectId: getSessionStorage('currentId')
        ? getSessionStorage('currentId')
        : '',
      connectedPage: vals.connectedPage,
      category: vals.category,
      description: vals.description,
      enableNotification: vals.enableNotification,
      reporterName: userInfo.name,
      reporterEmail: userInfo.cloudEmail || userInfo.email,
    };

    if (hasSelectedNoCompany) {
      Object.assign(data, {
        companyWebsite: vals.companyWebsite,
        companyName: vals.companyName,
      });
    }

    const res = await API.reportIssue(data);
    if (res && res.success) {
      close();
      setIsloading(false);
    }
  };

  const haveRequiredAreasFilled = (values, selectedNoCompany) => {
    const res = values.category && values.connectedPage && values.description;
    if (!selectedNoCompany) {
      return res;
    }
    return res && values.companyName && values.companyWebsite;
  };

  const geMandatoryFieldsVal = () => {
    const selectedNoCompany = form.getFieldsValue().category === categoryArr[1];

    if (!selectedNoCompany) {
      form.resetFields(['companyName', 'companyWebsite']);
    }

    setSelectedNoCompany(selectedNoCompany);
    const vals = form.getFieldsValue();

    if (haveRequiredAreasFilled(vals, selectedNoCompany)) {
      vals.description.trim() && setDisable(false);
    } else {
      setDisable(true);
    }

    if (
      vals.category === categoryArr[2] &&
      vals.connectedPage === connectedPageArr[0]
    ) {
      setPlaceholder(
        'Please provide the full name, GUID, email address for the users who cannot be found on the page.',
      );
    } else {
      setPlaceholder('');
    }
  };

  useEffect(() => {
    const curValues = form.getFieldsValue();

    if (
      Object.keys(defaultValues).length === 0 ||
      Object.keys(defaultValues).every((k) => defaultValues[k] === curValues[k])
    ) {
      return;
    }

    form.setFieldsValue(defaultValues);
    geMandatoryFieldsVal();
  }, [defaultValues]);

  const selectGetContainerCb = () =>
    document.getElementById('issue-content-box');

  const content = (
    <Spin spinning={dataLoading}>
      <div className="issue-content-box" id="issue-content-box">
        <div className="issue-head">
          Report Issue
          <span className="appkiticon icon-close-outline" onClick={close} />
        </div>
        <Form
          name="issue-body"
          form={form}
          layout="vertical"
          autoComplete="off"
          onFinish={onFinish}
        >
          <Item label="Connected Page" name="connectedPage">
            <Select
              allowClear
              dropdownClassName="report-issue-dropdown"
              onChange={geMandatoryFieldsVal}
              getPopupContainer={selectGetContainerCb}
            >
              {connectedPages.map((item, i) => (
                <Option value={item} key={i}>
                  {item}
                </Option>
              ))}
            </Select>
          </Item>
          <Item label="Issue Category" name="category">
            <Select
              allowClear
              dropdownClassName="report-issue-dropdown"
              onChange={geMandatoryFieldsVal}
              getPopupContainer={selectGetContainerCb}
            >
              {categoryArr.map((item, i) => (
                <Option value={item} key={i}>
                  {item}
                </Option>
              ))}
            </Select>
          </Item>
          {hasSelectedNoCompany && (
            <>
              <Item label="Company Name" name="companyName">
                <Input onChange={geMandatoryFieldsVal} />
              </Item>
              <Item label="Company Website" name="companyWebsite">
                <Input onChange={geMandatoryFieldsVal} />
              </Item>
            </>
          )}
          <div className="textarea-box">
            <Item label="Issue Description" name="description">
              <TextArea
                maxLength={limitNum}
                onChange={(e) => {
                  geMandatoryFieldsVal();
                  setDescriptionText(e.target.value);
                }}
                placeholder={placeholder}
                style={{
                  height: hasSelectedNoCompany ? '4.5rem' : '11.25rem',
                }}
              />
            </Item>
            <div className="count-num">{`(${descriptionText.length}/${limitNum})`}</div>
          </div>
          <Item
            className="check-box"
            name="enableNotification"
            style={{ marginTop: 12 }}
            valuePropName="checked"
            initialValue={true}
          >
            <Checkbox>Notify me with updates on this issue.</Checkbox>
          </Item>
          <div className="btn-box">
            <Button isLoading={isLoading} className="cancel" onClick={close}>
              cancel
            </Button>
            <Button
              isLoading={isLoading}
              disabled={disable}
              className="create"
              type="primary"
              htmlType="submit"
            >
              create
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
  return (
    <Toast
      isShow={isShow}
      contentStyles={{
        height: 'auto',
        width: 600,
        padding: '1.688rem 1.875rem',
      }}
      content={content}
    />
  );
};

const mapStateToProps = ({ login, common }) => ({
  userInfo: login.userInfo,
  isShow: common.isReportIssueModalShown,
  defaultValues: common.reportIssueDefaultValue,
});

const mapDispatchToProps = (dispatch) => ({
  close: () => {
    dispatch(actions.toggleReportIssueModal(false));
    dispatch(actions.changeReportIssueValues({}));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportIssue);
